let itemsData = [{
  "sku_id": 1000271,
  "title": "硬件开发",
  "sub_title": "嵌入式开发",
  "ali_image": require('@/assets/img/products/develop/hard/harddevelop1.jpg'),
  "model": 'v1.3',
  "ali_images": [
    {'image':require('@/assets/img/products/develop/hard/harddevelop1.jpg')},
    {'image':require('@/assets/img/products/develop/hard/harddevelop2.jpg')},

  ],
  'tech':[
    '可以根据客户需求对硬件进行开发或者调整',
    '对微信小程序、手机APP及远程4G钥匙进行授权等管理11',
    '可以查询授权记录，开锁记录',
    '可以对钥匙进行禁止授权等操作',
    '实时推送授权记录和开锁记录'
  ],
  'detail':'此两种型号无源锁用于光缆交接箱，均采用无源锁芯，锁体安装尺寸与光缆交接箱机械锁体完全兼容，安装时无需改变箱体开孔尺寸。具有唯一32位ＩＤ编码，采用电子钥匙外部供电，有记录开锁电子钥匙ID和时间功能。KS0184-1型号无源锁为三点锁紧，KS0184-2型号无源锁为单点锁紧。'
  ,'pdf_url':''
},{
  "sku_id": 1000299,
  "title": "微信小程序开发",
  "sub_title": "可以对蓝牙钥匙、指纹钥匙、远程4G钥匙进行管理",
  "ali_image": require('@/assets/img/products/software/wxMini/authDetail.jpg'),
  "model": 'v1.0.2',
  "ali_images": [
    {'image':require('@/assets/img/products/software/wxMini/authDetail.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/authHistory.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/remotekey.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/home.jpg')},
    {'image':require('@/assets/img/products/software/wxMini/open_record.jpg')},
  ],
  'tech':[
    '登录服务器获取授权信息',
    '通过蓝牙对电子钥匙进行设置权限、上传开锁记录等操作',
    '可以安装设备、查询授权记录和开锁记录',
    '可以对指纹钥匙进行指纹录入和删除操作'
  ],
//'pdf_url':'led.pdf'
},
{
  "sku_id": 1000300,
  "title": "手机APP开发",
  "sub_title": "安卓版",
  "ali_image": require('@/assets/img/products/software/app/authkey.png'),
  "model": 'v1.3',
  "ali_images": [
    {'image':require('@/assets/img/products/software/app/authkey.jpg')},
    {'image':require('@/assets/img/products/software/app/authhistory.jpg')},
    {'image':require('@/assets/img/products/software/app/finger.jpg')},
    {'image':require('@/assets/img/products/software/app/home.jpg')},
    {'image':require('@/assets/img/products/software/app/install.jpg')},
  ],
  'tech':[
    '可以对区域、设备、账户进行操作',
    '对微信小程序、手机APP及远程4G钥匙进行授权等操作',
    '可以查询授权记录，开锁记录',
    '可以对钥匙进行禁止授权等操作'
  ],
  'detail':'此两种型号无源锁用于光缆交接箱，均采用无源锁芯，锁体安装尺寸与光缆交接箱机械锁体完全兼容，安装时无需改变箱体开孔尺寸。具有唯一32位ＩＤ编码，采用电子钥匙外部供电，有记录开锁电子钥匙ID和时间功能。KS0184-1型号无源锁为三点锁紧，KS0184-2型号无源锁为单点锁紧。'
  ,'pdf_url':''
},
{
  "sku_id": 1000302,
  "title": "微信公众号开发",
  "sub_title": "跨平台",
  "ali_image": require("@/assets/img/products/software/gongzonghao/openrecord.jpg"),
  "model": 'v1.0',
  "ali_images": [
    {'image':require("@/assets/img/products/software/gongzonghao/openrecord.jpg")},
//  {'image':require('@/assets/img/products/software/app/authhistory.jpg')},
//  {'image':require('@/assets/img/products/software/app/finger.jpg')},
//  {'image':require('@/assets/img/products/software/app/home.jpg')},
//  {'image':require('@/assets/img/products/software/app/install.jpg')},
  ],
  'tech':[
    '可实时接收开锁记录、授权记录',
    '对授权信息进行管理',
    '可以查询授权记录，开锁记录',
    '可以对钥匙进行禁止授权等操作'
  ],
  'pdf_url':''
}
]

export default itemsData



// WEBPACK FOOTER //
// ./src/lib/developDetailData.js